import { Reveal } from "./Reveal";

export const SectionHeading = ({ overline, title, subtitle, dark = false, align = "left", className = "" }) => (
    <div className={`${align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-3xl"} ${className}`}>
        {overline && (
            <Reveal>
                <div className={`flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}>
                    <span className="h-px w-8 bg-brand" />
                    <span className={`text-xs uppercase tracking-[0.25em] font-semibold ${dark ? "text-brand" : "text-brand"}`}>
                        {overline}
                    </span>
                </div>
            </Reveal>
        )}
        <Reveal delay={0.05}>
            <h2 className={`font-display font-extrabold tracking-tight mt-5 text-3xl sm:text-4xl lg:text-5xl leading-[1.05] ${dark ? "text-white" : "text-navy"}`}>
                {title}
            </h2>
        </Reveal>
        {subtitle && (
            <Reveal delay={0.1}>
                <p className={`mt-5 text-base lg:text-lg leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"}`}>
                    {subtitle}
                </p>
            </Reveal>
        )}
    </div>
);
